module.exports = __webpack_public_path__ + "img/p8_6.b316cc9f.png";